module.exports = __webpack_public_path__ + "img/block1mindremobil.1527df7c.jpg";